import { useTranslation } from "react-i18next";
import { rawItems } from "../filters/useFilterSex";
import singleMode from "./selectBaseSingle";
import multiMode from "./selectBaseMulti";

export default ({ multiple, initial }) => {
	const { t } = useTranslation(["common"]);
	const items = rawItems.map(item => ({
		...item,
		content: t(`sexOptions.${item.key}`),
	}));
	const compute = multiple
		? {
				valueToApiParam: values =>
					values.map(
						value =>
							items.find(item => item.value === value).meta.url
					),
				apiParamToValue: values =>
					values.map(
						value => items.find(item => item.key === value).value
					),
		  }
		: {
				valueToApiParam: value => {
					const current = items.find(item => item.value === value);
					return current ? current.meta.url : null;
				},
				apiParamToValue: value => {
					const newValue = items.find(item => item.key === value)[0]
						.value;
					return newValue;
				},
		  };

	let computedInitial = null;
	if (Array.isArray(initial)) {
		computedInitial = initial
			? initial.map(sex => ({
					value: items.find(item => item.key === sex).value,
			  }))
			: [];
	} else if (typeof initial === "string") {
		computedInitial = items.find(item => item.key === initial).value;
	}
	return {
		rawItems,
		items,
		compute,
		isMultiple: multiple,
		...(multiple
			? multiMode({ items, initial: computedInitial })
			: singleMode({ items, initial: computedInitial })),
	};
};
